import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  padding: '0',
  backgroundColor: theme.palette.background.grey.main,
  overflowX: 'hidden'
}));

export const WrapperStyled = styled(Stack)(({ theme }) => ({
  width: '100%',
  gridColumn: '1 / 5',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
}));

export const TabWrapperStyled = styled(Stack)(({ theme }) => ({
  width: '100%',
  gridColumn: '1 / 5',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '5 / 9'
  }
}));

export const TabBoxStyled = styled(Box)(() => ({
  borderBottom: '1px solid',
  borderColor: 'rgba(0, 0, 0, 0.10)'
}));
